import { SidebarMenu } from '../interfaces/sidebar-menu/sidebar-menu';
import { UniversityService } from '../services/university/university.service';
import { permissionEntity } from './permission';
import { urlRoutes } from './url-route.constant';

export const sidebarMenu: SidebarMenu[] = [
    {
        isActive: false,
        icon: 'flaticon-menu-1',
        menuName: 'SIDEBAR.MENUS.DASHBOARD.TEXT',
        badge: '7',
        url: `/${urlRoutes.mainLayout}`,
        permission: [permissionEntity.modules.dashboard],
        subMenus: [
            { url: '/', menuName: 'SIDEBAR.MENUS.DASHBOARDS.TEXT' },
            { url: '/analytics', menuName: 'SIDEBAR.MENUS.DASHBOARDS.TEXT' },
            {
                url: '/project-management',
                menuName: 'SIDEBAR.MENUS.DASHBOARDS.TEXT',
            },
            { url: '/lms-courses', menuName: 'SIDEBAR.MENUS.DASHBOARDS.TEXT' },
            { url: '/crypto', menuName: 'SIDEBAR.MENUS.DASHBOARDS.TEXT' },
            { url: '/help-desk', menuName: 'SIDEBAR.MENUS.DASHBOARDS.TEXT' },
            { url: '/saas-app', menuName: 'SIDEBAR.MENUS.DASHBOARDS.TEXT' },
        ],
    },
    {
        isActive: false,
        icon: 'flaticon-menu-1',
        menuName: 'MM Dashboard',
        badge: '7',
        url: `/${urlRoutes.mainLayout}/${urlRoutes.dashboardmm}`,
        permission: [
            permissionEntity.modules.dashboardmm
        ],
        subMenus: [],
    },
    {
        isActive: false,
        icon: 'flaticon-menu-1',
        menuName: 'RM Dashboard',
        badge: '7',
        url: `/${urlRoutes.mainLayout}/${urlRoutes.dashboardrm}`,
        permission: [
            permissionEntity.modules.dashboardrm
        ],
        subMenus: [],
    },
    {
        isActive: false,
        icon: 'flaticon-menu-1',
        menuName: 'URM Dashboard',
        badge: '7',
        url: `/${urlRoutes.mainLayout}/${urlRoutes.dashboardurm}`,
        permission: [
            permissionEntity.modules.dashboardurm
        ],
        subMenus: [],
    },
    {
        isActive: false,
        icon: 'flaticon-menu-1',
        menuName: 'Application Dashboard',
        badge: '7',
        url: `/${urlRoutes.mainLayout}/${urlRoutes.dashboardrmwithOutpremission}`,
        permission: [permissionEntity.modules.dashboard],
        subMenus: [],
    },
    // {
    //     isActive: false,
    //     icon: 'flaticon-user',
    //     menuName: 'SIDEBAR.MENUS.AGENT.TEXT',
    //     badge: null,
    //     url: `/${urlRoutes.mainLayout}/${urlRoutes.agent}`,
    //     permission: [permissionEntity.modules.agents],
    //     subMenus: [
    //         { url: `/${urlRoutes.mainLayout}/${urlRoutes.agent}`, menuName: 'SIDEBAR.MENUS.AGENT.AGENT' },
    //         { url: `/${urlRoutes.mainLayout}/${urlRoutes.counsellor}`, menuName: 'SIDEBAR.MENUS.AFFILATE.TEXT' },
    //     ],
    // },

    {
        isActive: false,
        icon: 'flaticon-user',
        menuName: 'SIDEBAR.MENUS.AGENT.TEXT',
        badge: null,
        permission: [
            permissionEntity.modules.agents,
            permissionEntity.modules.non_approved_agent
        ],
        // url: `/${urlRoutes.mainLayout}/${urlRoutes.agent}`,
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.agent}`,
                menuName: 'SIDEBAR.MENUS.AGENT.AGENT',
                permission: [permissionEntity.modules.agents],
            },
            // {
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.approved_agent}`,
            //     menuName: 'SIDEBAR.MENUS.APPROVED_AGENT.APPROVED_AGENT',
            //     permission: [permissionEntity.modules.approved_agent],
            // },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.non_approved_agent}`,
                menuName: 'SIDEBAR.MENUS.NON_APPROVED_AGENT.TEXT',
                permission: [permissionEntity.modules.non_approved_agent],
            },
            // {
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.pending_bank_approval}`,
            //     menuName: 'SIDEBAR.MENUS.PENDING_BANK_APPROVAL.TEXT',
            //     permission: [permissionEntity.modules.pending_bank_approval],
            // },
            // {
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.inactive_agent}`,
            //     menuName: 'SIDEBAR.MENUS.INACTIVE_AGENT.TEXT',
            //     permission: [permissionEntity.modules.inactive_agent],
            // },
            // {
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.inactive_agent}`,
            //     menuName: 'Inactive Affiliate',
            //     permission: [permissionEntity.modules.inactive_agent]
            // },
            // {
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.inactive_agent}`,
            //     menuName: 'Nonpayment Affiliate',
            //     permission: [permissionEntity.modules.inactive_agent]
            // }
        ],
    },
    {
        icon: 'flaticon-user',
        menuName: 'Search Agent',
        badge: null,
        isActive: false,
        url: `/${urlRoutes.mainLayout}/${urlRoutes.search_agent}`,
        permission: [permissionEntity.modules.search_agent],
        subMenus: [
        ],
    },

    {
        isActive: false,
        icon: 'flaticon-to-do-list',
        menuName: 'SIDEBAR.MENUS.APPLICATION_MASTER.TEXT',
        badge: null,
        url: `/${urlRoutes.mainLayout}/${urlRoutes.application_master}`,
        permission: [permissionEntity.modules.applications],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.application_master}`,
                menuName: 'SIDEBAR.MENUS.APPLICATION_MASTER.ALL_APPLICATIONS',
            },
        ],
    },
    {
        icon: 'flaticon-layer-1',
        menuName: 'Application (Archived)',
        badge: null,
        isActive: false,
        url: `/${urlRoutes.mainLayout}/${urlRoutes.application_master}/${urlRoutes.archived}`,
        permission: [permissionEntity.modules.archived],
        subMenus: [
        ],
    },
    {
        isActive: false,
        icon: 'flaticon-bell',
        menuName: 'Notification Master',
        badge: null,
        url: `/${urlRoutes.mainLayout}/${urlRoutes.notification_master}`,
        // permission: [permissionEntity.modules.notifications],
        permission: [permissionEntity.modules.notification],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.notification_master}`,
                menuName: 'Notification Master',
            },
        ],
    },

    {
        isActive: false,
        icon: 'ri-robot-2-line',
        menuName: 'Automation',
        badge: null,
        // permission: [permissionEntity.modules.automation],
        permission: [permissionEntity.modules.automation],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.automation}`,
                menuName: 'Automation',
                permission: [permissionEntity.modules.automation_list]
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.automation}/${urlRoutes.automationoptions}`,
                menuName: 'Automation Option List',
                permission: [permissionEntity.modules.automation_option_list]
            }
        ],
    },

    {
        isActive: false,
        icon: 'flaticon-chat',
        menuName: 'Chat Master',
        badge: null,
        // url: `/${urlRoutes.mainLayout}/${urlRoutes.chat_master}`,
        // permission: [permissionEntity.modules.chat],
        // permission: [permissionEntity.modules.applications],
        permission: [
            permissionEntity.modules.support_chat
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.chat_master}/${urlRoutes.chat_active}`,
                menuName: 'Active Chat',
                permission: [permissionEntity.modules.active_chat],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.chat_master}/${urlRoutes.chat_history}`,
                menuName: 'Chat History',
                permission: [permissionEntity.modules.support_chat_history],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.chat_master}/${urlRoutes.chat_all}`,
                menuName: 'All Chat',
                permission: [permissionEntity.modules.support_chat_history],
            },
        ],
    },

    {
        isActive: false,
        icon: 'flaticon-layer',
        menuName: 'SIDEBAR.MENUS.FILE_MANAGER.TEXT',
        badge: null,
        // url: `/${urlRoutes.mainLayout}/${urlRoutes.my_drive}`,
        permission: [permissionEntity.modules.my_drive],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.file_manager}/${urlRoutes.my_drive}`,
                menuName: 'SIDEBAR.MENUS.FILE_MANAGER.MY_DRIVE',
                permission: [permissionEntity.modules.my_drive],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.file_manager}/${urlRoutes.important}`,
                menuName: 'SIDEBAR.MENUS.FILE_MANAGER.IMPORTANT',
                permission: [permissionEntity.modules.my_drive],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.file_manager}/${urlRoutes.shared_with_me}`,
                menuName: 'SIDEBAR.MENUS.FILE_MANAGER.SHARED_WITH_ME',
                permission: [permissionEntity.modules.my_drive],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.file_manager}/${urlRoutes.shared_by_me}`,
                menuName: 'SIDEBAR.MENUS.FILE_MANAGER.SHARED_BY_ME',
                permission: [permissionEntity.modules.my_drive],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.file_manager}/${urlRoutes.shared_by_me}`,
                redirectTo: true,
                menuName: 'Shared Drive',
                permission: [permissionEntity.modules.my_drive],
            },
        ],
    },
    {
        isActive: false,
        icon: 'flaticon-user',
        menuName: 'SIDEBAR.MENUS.UNIVERSITY_MASTER.TEXT',
        badge: null,
        permission: [
            permissionEntity.modules.university_cat_cpt_art,
            permissionEntity.modules.university,
            permissionEntity.modules.universities_entry_requirement,
            permissionEntity.modules.university_affiliate,
            permissionEntity.modules.universities_process_link,
            permissionEntity.modules.universities_filter_master,
            permissionEntity.modules.university_filter_pg,
            permissionEntity.modules.university_filter_ug,
        ],
        subMenus: [
            // {
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.university_cat_cpt_art}`,
            //     menuName: 'SIDEBAR.MENUS.UNIVERSITY_CAT_CPT_ART.TEXT',
            //     permission: [permissionEntity.modules.university_cat_cpt_art]
            // },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.university}`,
                menuName: 'SIDEBAR.MENUS.UNIVERSITY.TEXT',
                permission: [permissionEntity.modules.university],
            },
            // {
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.university_entry}`,
            //     menuName: 'SIDEBAR.MENUS.UNIVERSITY_ENTRY.TEXT',
            //     permission: [
            //         permissionEntity.modules.universities_entry_requirement,
            //     ],
            // },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.university_affliate}`,
                menuName: 'SIDEBAR.MENUS.UNIVERSITY_AFFILIATE.TEXT',
                permission: [permissionEntity.modules.university_affiliate],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.university_process_link}`,
                menuName: 'SIDEBAR.MENUS.UNIVERSITY_PROCESS_LINK.TEXT',
                permission: [
                    permissionEntity.modules.universities_process_link,
                ],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.university_filter_master}`,
                menuName: 'SIDEBAR.MENUS.UNIVERSITY_FILTER_MASTER.TEXT',
                permission: [
                    permissionEntity.modules.universities_filter_master,
                ],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.university_filter_pg}`,
                menuName: 'SIDEBAR.MENUS.UNIVERSITY_FILTER_PG.TEXT',
                permission: [permissionEntity.modules.university_filter_pg],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.university_filter_ug}`,
                menuName: 'SIDEBAR.MENUS.UNIVERSITY_FILTER_UG.TEXT',
                permission: [permissionEntity.modules.university_filter_ug],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.university_cat_cpt_art}`,
                menuName: 'SIDEBAR.MENUS.UNIVERSITY_CAT_CPT_ART.TEXT',
                permission: [permissionEntity.modules.university_cat_cpt_art],
            },
        ],
    },
    {
        isActive: false,
        icon: 'flaticon-learning',
        menuName: 'SIDEBAR.MENUS.COURSEMASTER.TEXT',
        badge: null,
        permission: [
            permissionEntity.modules.courses,
            permissionEntity.modules.options,
            permissionEntity.modules.filters,
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.courses}`,
                menuName: 'SIDEBAR.MENUS.COURSES.TEXT',
                permission: [permissionEntity.modules.courses],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.options}`,
                menuName: 'SIDEBAR.MENUS.OPTIONS.TEXT',
                permission: [permissionEntity.modules.options],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.filters}`,
                menuName: 'SIDEBAR.MENUS.FILTERS.TEXT',
                permission: [permissionEntity.modules.filters],
            },
        ],
    },
    // {
    //     isActive: false,
    //     icon: 'flaticon-to-do-list',
    //     menuName: 'SIDEBAR.MENUS.FORM_MASTER.TEXT',
    //     badge: null,
    //     permission: [permissionEntity.modules.form_master_form],
    //     subMenus: [
    //         {
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.form_master}`,
    //             menuName: 'SIDEBAR.MENUS.FORM_MASTER.FORM_DETAILS',
    //             permission: [permissionEntity.modules.form_master_form],
    //         },
    //     ],
    // },
    {
        isActive: false,
        icon: 'flaticon-to-do-list',
        menuName: 'SIDEBAR.MENUS.ART.TEXT',
        badge: null,
        permission: [permissionEntity.modules.art_received],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.art}/${urlRoutes.art_assignment}`,
                menuName: 'SIDEBAR.MENUS.ART.ART_RECEIVED',
                permission: [permissionEntity.modules.art_received],
            },
        ],
    },
    // {
    //     isActive: false,
    //     icon: 'flaticon-online-shop',
    //     menuName: 'SIDEBAR.MENUS.CAT.TEXT',
    //     badge: null,
    //     permission: [permissionEntity.modules.cat_recieved],
    //     subMenus: [
    //         {
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.cat}/${urlRoutes.cat_app_recived}`,
    //             menuName: 'SIDEBAR.MENUS.CAT_APP_RECEIVED.TEXT',
    //             permission: [permissionEntity.modules.cat_recieved],
    //         },
    //         // {
    //         //     url: `/${urlRoutes.mainLayout}/${urlRoutes.cat}/${urlRoutes.cat_all_case}`,
    //         //     menuName: 'SIDEBAR.MENUS.CAT_APP_ALL_CASE.TEXT',
    //         //     permission: [permissionEntity.modules.cat_recieved],
    //         // },
    //         // {
    //         //     url: `/${urlRoutes.mainLayout}/${urlRoutes.cat}/${urlRoutes.cat_my_case}`,
    //         //     menuName: 'SIDEBAR.MENUS.CAT_APP_OWN_CASE.TEXT',
    //         //     permission: [permissionEntity.modules.cat_recieved],
    //         // },
    //     ],
    // },
    {
        isActive: false,
        icon: 'flaticon-online-shop',
        menuName: 'Case Owner',
        badge: null,
        permission: [
            permissionEntity.modules.cat,
            permissionEntity.modules.cat_all_case,
            permissionEntity.modules.cat_my_case,
            permissionEntity.modules.cat_change_case_owner
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cat}/${urlRoutes.cat_all_case}`,
                menuName: 'SIDEBAR.MENUS.CAT_APP_ALL_CASE.TEXT',
                permission: [permissionEntity.modules.cat_all_case],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cat}/${urlRoutes.cat_my_case}`,
                menuName: 'SIDEBAR.MENUS.CAT_APP_OWN_CASE.TEXT',
                permission: [permissionEntity.modules.cat_my_case],
            },
            // {
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.cat}/${urlRoutes.cat_coar}`,
            //     menuName: 'SIDEBAR.MENUS.CAT_APP_OWN_COAR.TEXT',
            //     permission: [permissionEntity.modules.cat_recieved],
            // }
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cat}/${urlRoutes.cat_change_case_owner}`,
                menuName: 'SIDEBAR.MENUS.CAT_CHANGE_CASE_OWNER.TEXT',
                permission: [permissionEntity.modules.cat_change_case_owner],
            }
        ],
    },
    {
        isActive: false,
        icon: 'flaticon-online-shop',
        menuName: 'SIDEBAR.MENUS.CPT.TEXT',
        badge: null,
        permission: [
            permissionEntity.modules.cpt,
            permissionEntity.modules.cpt_assign_application,
            permissionEntity.modules.cpt_document_verification,
            permissionEntity.modules.cpt_processed_application,
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cpt}/${urlRoutes.cpt_document_verification}`,
                menuName: 'SIDEBAR.MENUS.DOCUMENT_VERIFICATION.TEXT',
                permission: [
                    permissionEntity.modules.cpt_document_verification,
                ],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cpt}/${urlRoutes.cpt_application}`,
                menuName: 'SIDEBAR.MENUS.ASSIGN_APPLICATION.TEXT',
                permission: [permissionEntity.modules.cpt_assign_application],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cpt}/${urlRoutes.cpt_processed_application}`,
                menuName: 'SIDEBAR.MENUS.PROCESSED_APPLICATION.TEXT',
                permission: [
                    permissionEntity.modules.cpt_processed_application,
                ],
            },
        ],
    },
    //InterviewMaster
    {
        isActive: false,
        icon: 'flaticon-online-shop',
        menuName: 'SIDEBAR.MENUS.CCT.TEXT',
        badge: null,
        permission: [
            permissionEntity.modules.cct,
            permissionEntity.modules.cct_interview_master,
            permissionEntity.modules.cct_interview_request,
            permissionEntity.modules.cct_quality_master,
            permissionEntity.modules.cct_view_interview,
            permissionEntity.modules.cct_assign_interview,
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cct}/${urlRoutes.cct_interview_master}`,
                menuName: 'SIDEBAR.MENUS.INTERVIEW_MASTER.TEXT',
                permission: [permissionEntity.modules.cct_interview_master],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cct}/${urlRoutes.cct_interview_request}`,
                menuName: 'SIDEBAR.MENUS.INTERVIEW_REQUEST.TEXT',
                permission: [permissionEntity.modules.cct_interview_request],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cct}/${urlRoutes.cct_interview_assign}`,
                menuName: 'SIDEBAR.MENUS.INTERVIEW_ASSIGN.TEXT',
                permission: [permissionEntity.modules.cct_assign_interview],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cct}/${urlRoutes.cct_batch_interview_assign}`,
                menuName: 'SIDEBAR.MENUS.BATCH_INTERVIEW_ASSIGN.TEXT',
                permission: [permissionEntity.modules.cct_assign_interview],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cct}/${urlRoutes.cct_view_interview}`,
                menuName: 'SIDEBAR.MENUS.VIEW_INTERVIEW.TEXT',
                permission: [permissionEntity.modules.cct_view_interview],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.cct}/${urlRoutes.cct_quality_master}`,
                menuName: 'SIDEBAR.MENUS.QUALITY_MASTER.TEXT',
                permission: [permissionEntity.modules.cct_quality_master],
            },
        ],
    },

    //Notice Board
    {
        isActive: false,
        icon: 'flaticon-online-shop',
        menuName: 'SIDEBAR.MENUS.NOTICE.TEXT',
        badge: null,
        permission: [
            permissionEntity.modules.admin_notice_board,
            permissionEntity.modules.agent_notice_board,
            permissionEntity.modules.agent_webinar_board,
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.notice_board}/${urlRoutes.admin_notice_board}`,
                menuName: 'SIDEBAR.MENUS.ADMIN_NOTICE.TEXT',
                permission: [permissionEntity.modules.admin_notice_board],
            },
            {
                menuName: 'SIDEBAR.MENUS.FRONTEND_NOTICE.TEXT',
                permission: [
                    permissionEntity.modules.agent_notice_board,
                    permissionEntity.modules.agent_webinar_board,
                ],
                subMenus: [
                    {
                        url: `${urlRoutes.notice_board}/${urlRoutes.frontend_notice_board}/${urlRoutes.frontend_notice}`,
                        menuName: 'SIDEBAR.MENUS.FRONTEND_IMAGE_NOTICE.TEXT',
                        permission: [
                            permissionEntity.modules.agent_notice_board,
                        ],
                    },
                    {
                        url: `${urlRoutes.notice_board}/${urlRoutes.frontend_notice_board}/${urlRoutes.frontend_webinar_notice}`,
                        menuName: 'SIDEBAR.MENUS.FRONTEND_WEBINAR.TEXT',
                        permission: [
                            permissionEntity.modules.agent_webinar_board,
                        ],
                    },
                ],
            },
        ],
    },
    {
        isActive: false,
        icon: 'flaticon-insurance',
        menuName: 'SIDEBAR.MENUS.ADMINMASTER.TEXT',
        badge: null,
        permission: [
            permissionEntity.modules.admin_master,
            permissionEntity.modules.loan,
            permissionEntity.modules.cabin,
            permissionEntity.modules.company,
            permissionEntity.modules.employee_designation,
            permissionEntity.modules.job_role,
            permissionEntity.modules.country,
            permissionEntity.modules.state,
            permissionEntity.modules.regions,
            permissionEntity.modules.continents,
            permissionEntity.modules.document_restrictions,
            permissionEntity.modules.interview_type,
            permissionEntity.modules.interview_mode,
            permissionEntity.modules.form_master_form,
            permissionEntity.modules.religions,
            permissionEntity.modules.partners,
            permissionEntity.modules.accommodation,
            permissionEntity.modules.universitydeadline,
            permissionEntity.modules.internaloptions,
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.internaloptions}`,
                menuName: 'Internal Options',
                permission: [permissionEntity.modules.internaloptions],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_application_deadline}`,
                menuName: 'University Deadline',
                permission: [permissionEntity.modules.universitydeadline],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_loan}`,
                menuName: 'Loan',
                permission: [permissionEntity.modules.loan],
            },
             {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_loan}/${urlRoutes.loan_enquiry_list}`,
                menuName: 'Loan Enquiry List',
                permission: [permissionEntity.modules.loan],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_cabin}`,
                menuName: 'SIDEBAR.MENUS.ADMIN_MASTER_CABIN.TEXT',
                permission: [permissionEntity.modules.cabin],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_company}`,
                menuName: 'SIDEBAR.MENUS.ADMIN_MASTER_COMPANY.TEXT',
                permission: [permissionEntity.modules.company],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_aiinterview}`,
                menuName: 'AI Interview',
                permission: [permissionEntity.modules.aiInterview],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_employee_designation}`,
                menuName:
                    'SIDEBAR.MENUS.ADMIN_MASTER_EMPLOYEE_DESIGNATION.TEXT',
                permission: [permissionEntity.modules.employee_designation],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_job_role}`,
                menuName: 'SIDEBAR.MENUS.ADMIN_JOB_ROLE.TEXT',
                permission: [permissionEntity.modules.job_role],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_country_section}`,
                menuName: 'SIDEBAR.MENUS.ADMIN_COUNTRY.TEXT',
                permission: [permissionEntity.modules.country],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_state}`,
                menuName: 'SIDEBAR.MENUS.ADMIN_STATE.TEXT',
                permission: [permissionEntity.modules.state],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_regions}`,
                menuName: 'SIDEBAR.MENUS.ADMIN_REGIONS.TEXT',
                permission: [permissionEntity.modules.regions],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_continents}`,
                menuName: 'SIDEBAR.MENUS.ADMIN_CONTINETS.TEXT',
                permission: [permissionEntity.modules.continents],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.upload_doc_restrictions}`,
                menuName: 'SIDEBAR.MENUS.DOCUMENT_RESTRICTIONS.TEXT',
                permission: [permissionEntity.modules.document_restrictions],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.interview_type}`,
                menuName: 'SIDEBAR.MENUS.INTERVIEW_TYPE.TEXT',
                permission: [permissionEntity.modules.interview_type],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.interview_mode}`,
                menuName: 'SIDEBAR.MENUS.INTERVIEW_MODE.TEXT',
                permission: [permissionEntity.modules.interview_mode],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.form_master}`,
                menuName: 'SIDEBAR.MENUS.FORM_MASTER.FORM_DETAILS',
                permission: [permissionEntity.modules.form_master_form],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_religion}`,
                menuName: 'SIDEBAR.MENUS.ADMIN_RELIGION.TEXT',
                permission: [permissionEntity.modules.religions],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.internaloptions}`,
                menuName: 'Internal Options',
                permission: [permissionEntity.modules.religions],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.mail_rules}`,
                menuName: 'Mail Rules',
                permission: [permissionEntity.modules.mail_rule],
            },
            // {
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.admin_voucher}`,
            //     menuName: 'Voucher',
            //     permission: [permissionEntity.modules.cabin],
            // },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_master}/${urlRoutes.partners}`,
                menuName: 'Partners',
                permission: [permissionEntity.modules.partners],
            },

        ],
    },
    {
        icon: 'flaticon-online-shop',
        menuName: 'Accommodation',
        badge: null,
        isActive: false,
        permission: [
            permissionEntity.modules.cabin
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.accommodation}`,
                menuName: 'Amber',
                permission: [permissionEntity.modules.cabin],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.accommodation}/${urlRoutes.accommodation_enquiry_list}`,
                menuName: 'Enquiry List',
                permission: [permissionEntity.modules.cabin],
            },
        ],
    },
    {
        icon: 'flaticon-price-tag',
        menuName: 'Voucher',
        badge: null,
        isActive: false,
        url: `/${urlRoutes.mainLayout}/${urlRoutes.admin_voucher}`,
        permission: [permissionEntity.modules.voucher],
        subMenus: [
        ],
    },
    // {
    //     isActive: false,
    //     icon: 'flaticon-envelope',
    //     menuName: 'SIDEBAR.MENUS.EMAILMASTER.TEXT',
    //     badge: null,
    //     permission: [
    //         permissionEntity.modules.smtp,
    //         permissionEntity.modules.email_template,
    //         permissionEntity.modules.universities_email,
    //     ],
    //     subMenus: [
    //         {
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.email_master}/${urlRoutes.email_smtp}`,
    //             menuName: 'SIDEBAR.MENUS.ADMIN_MASTER_SMTP.TEXT',
    //             permission: [permissionEntity.modules.smtp],
    //         },
    //         {
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.email_master}/${urlRoutes.email_template}`,
    //             menuName: 'SIDEBAR.MENUS.ADMIN_MASTER_EMAIL_TEMPLATES.TEXT',
    //             permission: [permissionEntity.modules.email_template],
    //         },
    //         {
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.email_master}/${urlRoutes.university_email}`,
    //             menuName: 'SIDEBAR.MENUS.UNIVERSITY_EMAIL.TEXT',
    //             permission: [permissionEntity.modules.universities_email],
    //         },
    //     ],
    // },

    // University Communication
    // {
    //     isActive: false,
    //     icon: 'flaticon-chat',
    //     menuName: 'SIDEBAR.MENUS.UNIVERSITY_COMMUNICATIONS.TEXT',
    //     badge: null,
    //     permission: [
    //         permissionEntity.modules.mail_box,
    //         permissionEntity.modules.mmr_team,
    //     ],
    //     subMenus: [
    //         {
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.university_communications}/${urlRoutes.mail_box}`,
    //             menuName: 'SIDEBAR.MENUS.MAIL_BOX.TEXT',
    //             permission: [permissionEntity.modules.mail_box],
    //         },
    //         {
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.university_communications}/${urlRoutes.mmr_team}`,
    //             menuName: 'SIDEBAR.MENUS.MMR_TEAM.TEXT',
    //             permission: [permissionEntity.modules.mmr_team],
    //         },
    //     ],
    // },

    // {
    //     icon: 'flaticon-online-shop',
    //     menuName: 'SIDEBAR.MENUS.STORE_MASTER.TEXT',
    //     badge: null,
    //     isActive: false,
    //     permission: [
    //         permissionEntity.modules.store,
    //         permissionEntity.modules.sub_store,
    //     ],
    //     subMenus: [
    //         {
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.tenant}`,
    //             menuName: 'SIDEBAR.MENUS.TENANT.TEXT',
    //             permission: [permissionEntity.modules.store],
    //         },
    //         {
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.subTenant}`,
    //             menuName: 'SIDEBAR.MENUS.SUB_TENANT.TEXT',
    //             permission: [permissionEntity.modules.sub_store],
    //         },
    //     ],
    // },

    {
        icon: 'flaticon-tools',
        menuName: 'SIDEBAR.MENUS.MASTER_TOOL.TEXT',
        badge: null,
        isActive: false,
        permission: [
            permissionEntity.modules.board,
            permissionEntity.modules.marksheet_verfication,
            permissionEntity.modules.student_previous_qualification,
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.master_tools}/${urlRoutes.board}`,
                menuName: 'SIDEBAR.MENUS.BOARDNAME.TEXT',
                permission: [permissionEntity.modules.board],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.master_tools}/${urlRoutes.marksheet_verfication}`,
                menuName: 'SIDEBAR.MENUS.MARKSHEET_VERIFICATION.TEXT',
                permission: [permissionEntity.modules.marksheet_verfication],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.master_tools}/${urlRoutes.student_prev_qualification}`,
                menuName: 'SIDEBAR.MENUS.STUDENT_PREVIOUS_QUALIFICATION.TEXT',
                permission: [
                    permissionEntity.modules.student_previous_qualification,
                ],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.master_tools}/${urlRoutes.adhoc_data_dump_instituition}`,
                menuName: 'SIDEBAR.MENUS.ADDHOC_DATA_DUMP.TEXT',
                permission: [
                    permissionEntity.modules.student_previous_qualification,
                ],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.master_tools}/${urlRoutes.adhoc_data_dump_prevq}`,
                menuName: 'SIDEBAR.MENUS.ADDHOC_DATA_DUMP_PREVQ.TEXT',
                permission: [
                    permissionEntity.modules.student_previous_qualification,
                ],
            },
        ],
    },
    {
        icon: 'flaticon-pulse',
        menuName: 'SIDEBAR.MENUS.APPLICATION_STATUS.TEXT',
        badge: null,
        isActive: false,
        permission: [
            permissionEntity.modules.application_primary_status,
            permissionEntity.modules.application_auto_changes,
            permissionEntity.modules.application_secondary_status,
            permissionEntity.modules.application_internal_status,
            permissionEntity.modules.application_communication_status,
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.application_status}/${urlRoutes.primary_status}`,
                menuName: 'SIDEBAR.MENUS.PRIMARY_STATUS.TEXT',
                permission: [
                    permissionEntity.modules.application_primary_status,
                ],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.application_status}/${urlRoutes.auto_change_status}`,
                menuName: 'SIDEBAR.MENUS.AUTO_CHANGES.TEXT',
                permission: [permissionEntity.modules.application_auto_changes],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.application_status}/${urlRoutes.secondary_status}`,
                menuName: 'SIDEBAR.MENUS.SECONDARY_STATUS.TEXT',
                permission: [
                    permissionEntity.modules.application_secondary_status,
                ],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.application_status}/${urlRoutes.internal_status}`,
                menuName: 'SIDEBAR.MENUS.INTERNAL_STATUS.TEXT',
                permission: [
                    permissionEntity.modules.application_internal_status,
                ],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.application_status}/${urlRoutes.communication_status}`,
                menuName: 'SIDEBAR.MENUS.COMMUNICATION_STATUS.TEXT',
                permission: [
                    permissionEntity.modules.application_communication_status,
                ],
            },
        ],
    },

    {
        icon: 'flaticon-setting',
        menuName: 'SIDEBAR.MENUS.SETTINGS.TEXT',
        badge: null,
        isActive: false,
        permission: [
            permissionEntity.modules.setting
        ],
        subMenus: [
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.ip_details}`,
                menuName: 'SIDEBAR.MENUS.IP_DETAILS.TEXT',
                permission: [permissionEntity.modules.ip_details],
            },
            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.link_builder}`,
                menuName: 'SIDEBAR.MENUS.LINK_BUILDER.TEXT',
                permission: [permissionEntity.modules.link_builder],
            },

            {
                url: `/${urlRoutes.mainLayout}/${urlRoutes.bank_mail_details}`,
                menuName: 'SIDEBAR.MENUS.BANK_MAIL_DETAILS.TEXT',
                permission: [permissionEntity.modules.bank_mail_details],
            },

            {
                icon: 'flaticon-people',
                menuName: 'SIDEBAR.MENUS.BACKENDUSERS.TEXT',
                badge: null,
                isActive: false,
                permission: [
                    permissionEntity.modules.users,
                    permissionEntity.modules.user_groups,
                ],
                subMenus: [
                    {
                        //? hide user menu
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.users}`,
                        menuName: 'SIDEBAR.MENUS.USERS.TEXT',
                        permission: [permissionEntity.modules.users],
                    },
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.users_groups}`,
                        menuName: 'SIDEBAR.MENUS.USERSGROUPS.TEXT',
                        permission: [permissionEntity.modules.user_groups],
                    },
                ],
            },

            {
                icon: 'flaticon-pulse',
                menuName: 'SIDEBAR.MENUS.APPLICATION_STATUS.TEXT',
                badge: null,
                isActive: false,
                permission: [
                    permissionEntity.modules.application_primary_status,
                    permissionEntity.modules.application_auto_changes,
                    permissionEntity.modules.application_secondary_status,
                    permissionEntity.modules.application_internal_status,
                    permissionEntity.modules.application_communication_status,
                ],
                subMenus: [
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.application_status}/${urlRoutes.primary_status}`,
                        menuName: 'SIDEBAR.MENUS.PRIMARY_STATUS.TEXT',
                        permission: [
                            permissionEntity.modules.application_primary_status,
                        ],
                    },
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.application_status}/${urlRoutes.auto_change_status}`,
                        menuName: 'SIDEBAR.MENUS.AUTO_CHANGES.TEXT',
                        permission: [
                            permissionEntity.modules.application_auto_changes,
                        ],
                    },
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.application_status}/${urlRoutes.secondary_status}`,
                        menuName: 'SIDEBAR.MENUS.SECONDARY_STATUS.TEXT',
                        permission: [
                            permissionEntity.modules
                                .application_secondary_status,
                        ],
                    },
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.application_status}/${urlRoutes.internal_status}`,
                        menuName: 'SIDEBAR.MENUS.INTERNAL_STATUS.TEXT',
                        permission: [
                            permissionEntity.modules
                                .application_internal_status,
                        ],
                    },
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.application_status}/${urlRoutes.communication_status}`,
                        menuName: 'SIDEBAR.MENUS.COMMUNICATION_STATUS.TEXT',
                        permission: [
                            permissionEntity.modules
                                .application_communication_status,
                        ],
                    },
                ],
            },

            {
                icon: 'flaticon-tools',
                menuName: 'SIDEBAR.MENUS.MASTER_TOOL.TEXT',
                badge: null,
                isActive: false,
                permission: [
                    permissionEntity.modules.board,
                    permissionEntity.modules.marksheet_verfication,
                    permissionEntity.modules.student_previous_qualification,
                ],
                subMenus: [
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.master_tools}/${urlRoutes.board}`,
                        menuName: 'SIDEBAR.MENUS.BOARDNAME.TEXT',
                        permission: [permissionEntity.modules.board],
                    },
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.master_tools}/${urlRoutes.marksheet_verfication}`,
                        menuName: 'SIDEBAR.MENUS.MARKSHEET_VERIFICATION.TEXT',
                        permission: [
                            permissionEntity.modules.marksheet_verfication,
                        ],
                    },
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.master_tools}/${urlRoutes.student_prev_qualification}`,
                        menuName:
                            'SIDEBAR.MENUS.STUDENT_PREVIOUS_QUALIFICATION.TEXT',
                        permission: [
                            permissionEntity.modules
                                .student_previous_qualification,
                        ],
                    },
                ],
            },
            {
                isActive: false,
                icon: 'flaticon-envelope',
                menuName: 'SIDEBAR.MENUS.EMAILMASTER.TEXT',
                badge: null,
                permission: [
                    permissionEntity.modules.email_master,
                    permissionEntity.modules.smtp,
                    permissionEntity.modules.email_template,
                    permissionEntity.modules.universities_email,
                ],
                subMenus: [
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.email_master}/${urlRoutes.email_smtp}`,
                        menuName: 'SIDEBAR.MENUS.ADMIN_MASTER_SMTP.TEXT',
                        permission: [permissionEntity.modules.smtp],
                    },
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.email_master}/${urlRoutes.email_template}`,
                        menuName:
                            'SIDEBAR.MENUS.ADMIN_MASTER_EMAIL_TEMPLATES.TEXT',
                        permission: [permissionEntity.modules.email_template],
                    },
                    {
                        url: `/${urlRoutes.mainLayout}/${urlRoutes.email_master}/${urlRoutes.university_email}`,
                        menuName: 'SIDEBAR.MENUS.UNIVERSITY_EMAIL.TEXT',
                        permission: [
                            permissionEntity.modules.universities_email,
                        ],
                    },
                ],
            },
        ],
    },

    {
        icon: 'flaticon-pulse',
        menuName: 'Reports',
        badge: null,
        isActive: false,
        // url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}`,
        permission: [
            permissionEntity.modules.reports,
            permissionEntity.modules.payment_reports
        ],
        subMenus: [
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.application_reports}`,
                menuName: 'Application Reports',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_received_reports}`,
                menuName: 'Application Received',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.agent_rating_reports}`,
                menuName: 'Agent Rating Report',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.agent_not_given_application_reports}`,
                menuName: 'Agent Not Given Application Report',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.application_intake_wise_reports}`,
                menuName: 'Application Intake Wise Report',
                permission: [permissionEntity.modules.application_reports],
            },
            // {
            //     //? hide user menu
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.agent_not_given_application_reports}`,
            //     menuName: 'Agent Not Given Application Report',
            //     permission: [permissionEntity.modules.application_reports],
            // },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_lifeline_reports}`,
                menuName: 'Application Lifeline Report',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_not_processed_reports}`,
                menuName: 'Application Not Processed Report',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_ok_processing_reports}`,
                menuName: 'Application Ok Processing Report',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_processed_reports}`,
                menuName: 'Application Processed Report',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_case_closed_reports}`,
                menuName: 'Application Case Closed Report',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_offer_issued_reports}`,
                menuName: 'Application offer Issued Report',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_with_cas_reports}`,
                menuName: 'Application With CAS Report',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.qc_reports}`,
                menuName: 'Individual Qc Report',
                permission: [permissionEntity.modules.qc_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_cas_to_req}`,
                menuName: 'Cas To Request Report',
                permission: [permissionEntity.modules.application_reports],
            },

            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_interview_reports}`,
                menuName: 'Interview Report',
                permission: [permissionEntity.modules.application_reports],
            },

            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_payment_reports}`,
                menuName: 'Payment Reports',
                permission: [permissionEntity.modules.payment_reports],
            },

            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_pst_reports}`,
                menuName: 'PST Reports',
                permission: [permissionEntity.modules.application_reports],
            },

            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_cpt_reports}`,
                menuName: 'CPT Reports',
                permission: [permissionEntity.modules.application_reports],
            },
            {
                //? hide user menu
                url: `/${urlRoutes.mainLayout}/${urlRoutes.reports}/${urlRoutes.app_timeline_reports}`,
                menuName: 'Timeline Of Application Reports',
                permission: [permissionEntity.modules.application_reports],
            },
        ],
    },

    // {
    //     icon: 'flaticon-people',
    //     menuName: 'SIDEBAR.MENUS.BACKENDUSERS.TEXT',
    //     badge: null,
    //     isActive: false,
    //     permission: [
    //         permissionEntity.modules.users,
    //         permissionEntity.modules.user_groups,
    //     ],
    //     subMenus: [
    //         {
    //             //? hide user menu
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.users}`,
    //             menuName: 'SIDEBAR.MENUS.USERS.TEXT',
    //             permission: [permissionEntity.modules.users],
    //         },
    //         {
    //             url: `/${urlRoutes.mainLayout}/${urlRoutes.users_groups}`,
    //             menuName: 'SIDEBAR.MENUS.USERSGROUPS.TEXT',
    //             permission: [permissionEntity.modules.user_groups],
    //         },
    //     ],
    // },
    // {
    //     icon: 'flaticon-contract',
    //     menuName: 'SIDEBAR.MENUS.FINANCIAL.TEXT',
    //     badge: null,
    //     isActive: false,
    //     permission: [
    //         permissionEntity.modules.agent_commission,
    //         permissionEntity.modules.university_contract,
    //     ],
    //     subMenus: [
    //         {
    //             menuName: 'SIDEBAR.MENUS.AGENT_FINANCE.TEXT',
    //             permission: [permissionEntity.modules.agent_commission],
    //             subMenus: [
    //                 {
    //                     url: `/${urlRoutes.mainLayout}/${urlRoutes.finance}/${urlRoutes.agent_finance}`,
    //                     menuName: 'SIDEBAR.MENUS.AGENT_COMMISSION.TEXT',
    //                     permission: [permissionEntity.modules.agent_commission],
    //                 },
    //                 // {
    //                 //     url: `/${urlRoutes.mainLayout}/${urlRoutes.finance}/${urlRoutes.agent_finance}/${urlRoutes.agent_global_commission}`,
    //                 //     menuName: 'SIDEBAR.MENUS.AGENT_GLOABL_COMMISSION.TEXT',
    //                 //     permission: [permissionEntity.modules.agent_commission]
    //                 // }

    //                 {
    //                     url: `/${urlRoutes.mainLayout}/${urlRoutes.finance}/${urlRoutes.agent_finance}/${urlRoutes.cas_master}`,
    //                     menuName: 'SIDEBAR.MENUS.CAS_MASTER.TEXT',
    //                     permission: [permissionEntity.modules.cas_master],
    //                 },
    //                 {
    //                     url: `/${urlRoutes.mainLayout}/${urlRoutes.finance}/${urlRoutes.agent_finance}/${urlRoutes.confirmation_awaited}`,
    //                     menuName: 'SIDEBAR.MENUS.CONFIRMATION_AWAITED.TEXT',
    //                     permission: [
    //                         permissionEntity.modules.confimation_awaited,
    //                     ],
    //                 },
    //                 {
    //                     url: `/${urlRoutes.mainLayout}/${urlRoutes.finance}/${urlRoutes.agent_finance}/${urlRoutes.ready_to_claim}`,
    //                     menuName: 'SIDEBAR.MENUS.READY_TO_CLAIM.TEXT',
    //                     permission: [permissionEntity.modules.ready_to_claim],
    //                 },
    //             ],
    //         },
    //         {
    //             menuName: 'SIDEBAR.MENUS.UNIVERSITY_FINANCIAL.TEXT',
    //             permission: [permissionEntity.modules.university_contract],
    //             subMenus: [
    //                 {
    //                     url: `/${urlRoutes.mainLayout}/${urlRoutes.finance}/${urlRoutes.university_finance}`,
    //                     menuName: 'SIDEBAR.MENUS.UNIVERSITY_CONTRACT.TEXT',
    //                     permission: [
    //                         permissionEntity.modules.university_contract,
    //                     ],
    //                 },
    //             ],
    //         },
    //         // {
    //         //     menuName: 'SIDEBAR.MENUS.INVOICE_MASTER.TEXT',
    //         //     permission: [
    //         //         permissionEntity.modules.university_contract
    //         //     ],
    //         //     subMenus: [
    //         //         {
    //         //             url: `/${urlRoutes.mainLayout}/${urlRoutes.finance}/${urlRoutes.invoice_finance}/${urlRoutes.create_invoice}`,
    //         //             menuName: 'SIDEBAR.MENUS.CREATE_INVOICE.TEXT',
    //         //             permission: [permissionEntity.modules.university_contract]
    //         //         },
    //         //         {
    //         //             url: `/${urlRoutes.mainLayout}/${urlRoutes.finance}/${urlRoutes.invoice_finance}/${urlRoutes.unpaid_invoice}`,
    //         //             menuName: 'Unpaid Invoice',
    //         //             permission: [permissionEntity.modules.university_contract]
    //         //         },
    //         //         {
    //         //             url: `/${urlRoutes.mainLayout}/${urlRoutes.finance}/${urlRoutes.invoice_finance}/${urlRoutes.paid_invoice}`,
    //         //             menuName: 'Paid Invoice',
    //         //             permission: [permissionEntity.modules.university_contract]
    //         //         },
    //         //         {
    //         //             url: `/${urlRoutes.mainLayout}/${urlRoutes.finance}/${urlRoutes.invoice_finance}/${urlRoutes.cancel_invoice}`,
    //         //             menuName: 'Cancel Invoice',
    //         //             permission: [permissionEntity.modules.university_contract]
    //         //         }
    //         //     ]
    //         // },
    //     ],
    // },
    {
        isActive: false,
        isMail: true,
        icon: 'flaticon-envelope',
        menuName: 'Crizac Mail',
        badge: null,
        isComponent: true,
        permission: [permissionEntity.modules.mail_box],
        subMenus: [
            // {
            //     menuName: 'SIDEBAR.MENUS.MAIL_BOX.TEXT',
            //     permission: [permissionEntity.modules.mail_box],
            //     subMenus: [
            //         {
            //             url: `/${urlRoutes.mainLayout}/${urlRoutes.mail_box}`,
            //             menuName: 'SIDEBAR.MENUS.MAIL_BOX.TEXT',
            //             permission: [permissionEntity.modules.mail_box],
            //         },
            //         {
            //             url: `/${urlRoutes.mainLayout}/${urlRoutes.mail_box}`,
            //             menuName: 'SIDEBAR.MENUS.MAIL_BOX.TEXT',
            //             permission: [permissionEntity.modules.mail_box],
            //         },
            //     ]
            // },
            // {
            //     url: `/${urlRoutes.mainLayout}/${urlRoutes.university_communications}/${urlRoutes.mmr_team}`,
            //     menuName: 'SIDEBAR.MENUS.MMR_TEAM.TEXT',
            //     permission: [permissionEntity.modules.mmr_team],
            // },
        ],
    },
    {
        icon: 'flaticon-layer-1',
        menuName: 'Call Logs',
        badge: null,
        isActive: false,
        url: `/${urlRoutes.mainLayout}/${urlRoutes.call_logs}`,
        permission: [permissionEntity.modules.call_logs],
        subMenus: [
        ],
    },
    {
        icon: 'flaticon-layer-1',
        menuName: 'AI Interview',
        badge: null,
        isActive: false,
        url: `/${urlRoutes.mainLayout}/${urlRoutes.ai_interview_logs}`,
        permission: [permissionEntity.modules.aiInterview],
        subMenus: [
        ],
    },
    {
        icon: 'flaticon-layer-1',
        menuName: 'Automation Log',
        badge: null,
        isActive: false,
        isAutoMation: false,
        url: `/${urlRoutes.mainLayout}/${urlRoutes.automation_log}`,
        permission: [permissionEntity.modules.automation],
        subMenus: [],
    },

    {
        isActive: false,
        icon: 'flaticon-layer',
        menuName: 'Activity Log',
        badge: null,
        url: `/${urlRoutes.mainLayout}/${urlRoutes.application_automation_log}`,
        permission: [permissionEntity.modules.automation],
        subMenus: [],
    },
    {
        icon: 'flaticon-layer-1',
        menuName: 'Referred QC',
        badge: null,
        isActive: false,
        url: `/${urlRoutes.mainLayout}/${urlRoutes.referred_qc}`,
        permission: [permissionEntity.modules.referred_qc],
        subMenus: [
        ],
    }
];
